import React from 'react';
import './about.style.css';
import video from '../../assets/videos/backgrounds/aboutVid.mp4';
import SEO from '../../SEO';

const About: React.FC = () => {
    return (
        <>
            <SEO 
                title="About Wild Chips Poker - Host your own poker game and invite your friends and play against them"
                description="Discover Wild Chips Poker - a unique poker game where strategy meets adventure. Learn about our multiplayer features, stunning graphics, and immersive gameplay experience."
                keywords="wild chips poker about, jungle poker game, poker strategy game, multiplayer poker, online poker game, poker adventure, poker host game, poker game host, poker game creator, poker game organizer"
                ogImage="/images/bgAbout-min.png"
                canonicalUrl="https://wildchipspoker.com/about"
            />
            <div className="all-pages-padding about-container">
                <div className="game-description">
                    <p>
                        Welcome to our exciting game world! Our game combines strategy, skill, and
                        entertainment to create an unforgettable gaming experience.
                    </p>
                    <p>
                        Whether you're a casual gamer or a hardcore enthusiast, our game offers
                        something for everyone. With stunning graphics, immersive sound design,
                        and intuitive controls, you'll find yourself completely absorbed in this
                        unique gaming adventure.
                    </p>
                    <p>
                        Connect with friends and create memorable moments together! You can easily
                        host your own games and invite friends to join you in multiplayer matches.
                        Compete against each other in exciting head-to-head
                        battles - the choice is yours. Our seamless multiplayer experience ensures
                        that sharing the fun is just a few clicks away.
                    </p>
                </div>
                <div className="about-video-container">
                    <video
                        className="about-video"
                        // autoPlay
                        // loop
                        // muted
                        // playsInline
                        controls
                    >
                        <source src={video} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </>
    );
};

export default About;

